import { useContext } from "react";

import type { DrawerContextValue } from "./_drawer-context";
import { DrawerContext } from "./_drawer-context";

export type { DrawerContextValue } from "./_drawer-context";

export const useClosestDrawer = (): undefined | DrawerContextValue => useContext(DrawerContext);
